import { render, staticRenderFns } from "./AdminAddPickupzoneModal.vue?vue&type=template&id=1568165a&"
import script from "./AdminAddPickupzoneModal.vue?vue&type=script&lang=js&"
export * from "./AdminAddPickupzoneModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports